import { useEffect, useState } from "react";
import { Keyboard } from "react-native";

const UseIsKeyboardOpen = () => {
    const [keyboardStatus, setKeyboardStatus] = useState('Keyboard Hidden');
    const [isKeyboardOpen, setIskeyboardOpen] = useState(false);

    useEffect(() => {
      const showSubscription = Keyboard.addListener('keyboardDidShow', () => {
        setKeyboardStatus('Keyboard Shown');
        setIskeyboardOpen(true);
      });
      const hideSubscription = Keyboard.addListener('keyboardDidHide', () => {
        setKeyboardStatus('Keyboard Hidden');
        setIskeyboardOpen(false);
      });
  
      return () => {
        showSubscription.remove();
        hideSubscription.remove();
      };
    }, []);

    return {isKeyboardOpen}
}

export default UseIsKeyboardOpen;